(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fitment-table"] && !Shopify.designMode) return;
  try {
    // Search filters every row; paging then shows 15 of whatever is left. The table
  // (desktop) and the cards (phone) are paged in step: both hold the same rows.
  const ftRender = (scope) => {
    const per = Number(scope.dataset.ftPerPage) || 15;
    const needle = (scope.querySelector('[data-ft-search]')?.value || '').trim().toLowerCase();
    const groups = [scope.querySelector('.ft__table tbody'), scope.querySelector('.ft__cards')].filter(Boolean);
    let pages = 1;
    groups.forEach((group) => {
      const rows = [...group.querySelectorAll('[data-ft-row]')];
      const hits = rows.filter((row) => needle === '' || (row.dataset.ftText || '').toLowerCase().includes(needle));
      pages = Math.max(1, Math.ceil(hits.length / per));
      const page = Math.min(Number(scope.dataset.ftPage) || 1, pages);
      scope.dataset.ftPage = page;
      rows.forEach((row) => {
        const i = hits.indexOf(row);
        row.classList.toggle('ft__row--hidden', i === -1);
        row.classList.toggle('ft__row--paged', i !== -1 && (i < (page - 1) * per || i >= page * per));
      });
    });
    const pager = scope.querySelector('[data-ft-pager]');
    if (!pager) return;
    const page = Number(scope.dataset.ftPage);
    pager.hidden = pages < 2;
    pager.querySelector('[data-ft-prev]').disabled = page <= 1;
    pager.querySelector('[data-ft-next]').disabled = page >= pages;
    pager.querySelector('[data-ft-info]').textContent =
      pager.dataset.label.replace('__C__', page).replace('__T__', pages);
  };

  document.addEventListener('input', (event) => {
    const field = event.target.closest('[data-ft-search]');
    if (!field) return;
    const scope = field.closest('.ft');
    scope.querySelector('[data-ft-search-clear]').hidden = !field.value;
    scope.dataset.ftPage = 1;
    ftRender(scope);
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ft-search-clear]');
    if (!btn) return;
    const field = btn.closest('.ft__search').querySelector('[data-ft-search]');
    field.value = '';
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.focus();
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ft-prev], [data-ft-next]');
    if (!btn) return;
    const scope = btn.closest('.ft');
    const page = Number(scope.dataset.ftPage) || 1;
    scope.dataset.ftPage = btn.hasAttribute('data-ft-next') ? page + 1 : page - 1;
    ftRender(scope);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fitment-verdict"] && !Shopify.designMode) return;
  try {
    // The card badge has its own handler on a different attribute; this one is
  // deliberately separate so the product page does not depend on a product card
  // happening to be rendered somewhere below it for the picker to open.
  document.addEventListener('click', (event) => {
    const bar = event.target.closest('[data-ezy-open-caravan]');
    if (!bar) return;
    if (typeof window.ezyOpenCaravanModal === 'function') {
      window.ezyOpenCaravanModal();
    } else if (bar.dataset.selector) {
      window.location.href = bar.dataset.selector;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
